<span class="" [ngSwitch]="messageLevel">
  <span class="icon-container" *ngSwitchCase="0"><mat-icon class="ac-message-icon error" svgIcon="error"></mat-icon></span>
  <span class="icon-container" *ngSwitchCase="1"><mat-icon class="ac-message-icon warning" svgIcon="warning"></mat-icon></span>
  <span class="icon-container" *ngSwitchCase="2"><mat-icon class="ac-message-icon info" svgIcon="info"></mat-icon></span>
  <span class="icon-placeholder" *ngSwitchDefault></span>
</span>
